export const siteInfo = {
  brand: '疯狂试爱2',
  slogan: '追踪每一次心动，解读每一段疯狂',
  intro:
    '「疯狂试爱2」官方网站是面向系列影视作品观众的内容门户，聚合最新影视资讯、深度剧情介绍与专题花絮，帮助影迷在第一时间掌握作品动态，并读懂剧情背后的情感表达。',
  contact: {
    email: 'contact@fengkuangshiai2.example.com',
    phone: '400-000-0000',
    address: '上海市静安区光影路 88 号影视创意园 7 号楼',
  },
  friends: [
    { name: '影视资料库', url: '/news' },
    { name: '剧情专题中心', url: '/category/plot' },
    { name: '花絮纪实', url: '/category/feature' },
    { name: '关于我们', url: '/about' },
  ],
  stats: [
    { label: '收录资讯', value: '320+' },
    { label: '剧情解析', value: '68' },
    { label: '专题策划', value: '24' },
    { label: '活跃影迷', value: '12.6万' },
  ],
};